import * as React from 'react';
import AppView from '~common/components/app-view/index';
import { Input, InputLabel, InputAdornment } from '@mui/material';
import { FormControl } from '@mui/material';
import { IconButton } from '@mui/material';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import  { withStyles } from '@mui/styles';

import { WithStyles, StyleRules, ClassNameMap } from '@mui/styles/withStyles';
import { Theme } from '@mui/styles';
import { TextField } from '@mui/material';
import Renderers from '~common/lib/renderers';
import { Button } from '@mui/material';
import { Typography } from '@mui/material';
import { Paper } from '@mui/material';
import { Grid } from '@mui/material';

const styles = (theme: Theme): StyleRules => ({
	container: {
		// marginTop: 40,
		display: 'flex',
		justifyContent: 'center'
	},
	paper: {
		width: 740,
		padding: 30,
		backgroundColor: 'white'
	},
	textField: {
		marginTop: 15,
		width: 350
	},
	passwordField: {
		width: 350
	},
	textFieldFull: {
		marginTop: 15,
		width: '100%'
	},
	passwordFull: {
		width: '100%'
	},
	form: {
		textAlign: 'left'
	},
	buttonBar: {
		textAlign: 'right',
		marginTop: 30
	},
	button: {
		width: 100
	},
	altButton: {
		width: 250
	},
	resetInstructions: {
		marginTop: 30
	},
	gridItem: {
		padding: 15,
		backgroundColor: 'white'
	},
	centalArea: {
		minHeight: 200
	},
	employeeInstructions: {
		paddingTop: 45
	},
	gridItemSep: {
		backgroundColor: '#fafafa',
		display: 'flex',
		alignContent: 'center',
		justifyContent: 'center'
	}
});



interface Props extends React.HTMLProps<HTMLDivElement> {
	history: any;
}

type State = {
	showPassword: boolean;
	data: any;
	redirectURL: string;
	requireCaptchaVerify: boolean;
};

class LoginRenderer extends React.Component<Props & WithStyles<keyof typeof styles>, State> {
	constructor(props: Props & WithStyles<keyof typeof styles>) {
		super(props, {});
		this.state = {
			showPassword: false,
			data: {
				userName: '',
				password: ''
			},
			redirectURL: '',
			requireCaptchaVerify: true
		};
	}

	componentDidMount() {
		var match,
			pl = /\+/g, // Regex for replacing addition symbol with a space
			search = /([^&=]+)=?([^&]*)/g,
			decode = function (s: string) {
				return decodeURIComponent(s.replace(pl, ' '));
			},
			query = window.location.search.substring(1);

		var urlParams: any = {};
		while ((match = search.exec(query))) {
			urlParams[decode(match[1])] = decode(match[2]);
		}

		// if (urlParams.redirectURL) {
			this.setState(
				{
					redirectURL: urlParams.redirectURL,
				}
			);
		// }
	}

    static register = () => {
        // console.log("Registering LoginRenderer")
        if(!Renderers.find("LoginRenderer")){
            // console.log("Registering LoginRenderer")
            Renderers.register("LoginRenderer", withStyles(styles)(LoginRenderer))
        }
    }

	UNSAFE_componentWillReceiveProps(newProps: Props & WithStyles<keyof typeof styles>) { }

	handleClickShowPasssword = () => {
		this.setState({ showPassword: !this.state.showPassword });
	};

	handleAltLogin = () => {
		window.location.href = '/saml-login';
	};

	handleChange = (prop: string) => {
		return (event: any) => {
			const state = this.state;
			state.data[prop] = event.target.value;
			this.setState(state);
		};
	};

	render() {
		var self = this;

		const { classes }: { classes: ClassNameMap } = this.props;
		const app = (window as any).App;
		var message: React.ReactNode;

		if (app.flash) {
			message = (
				<Typography variant="subtitle1" color={app.flash.type}>
					{app.flash.message}
				</Typography>
			);
		}


		let returnValue = (
				<div className={classes.container}>
					<Paper className={classes.paper}>
						<Typography variant="h5" gutterBottom>
							Please Login
						</Typography>
						{window["App"].samlAvailable && (
							<Grid container>
								<Grid item className={classes.gridItem} xs={12} sm={12} md={5} lg={5} xl={5}>
									<div>
										<Typography variant="h6" gutterBottom>
											Employees
										</Typography>
										<div className={classes.centalArea}>
											<Typography
												className={classes.employeeInstructions}
												variant="subtitle1"
												gutterBottom
											>
												{window["App"].browserEnvironment.BROWSER_EMPLOYEE_LOGIN_MESSAGE || `If you are an employee, you may login using the Single
												Sign-on integration by clicking the button below.`}
											</Typography>
										</div>
										<div className={classes.buttonBar}>
											<Button
												type="submit"
												variant="contained"
												color="primary"
												className={classes.altButton}
												onClick={this.handleAltLogin}
											>
												Login as Employee
											</Button>
										</div>
									</div>
								</Grid>
								<Grid item className={classes.gridItemSep} xs={12} sm={12} md={1} lg={1} xl={1}>
									<div />
								</Grid>
								<Grid item className={classes.gridItem} xs={12} sm={12} md={6} lg={6} xl={6}>
									<Typography variant="h6" gutterBottom>
										Vendors
									</Typography>
									<form className={classes.form} noValidate autoComplete="off" method="POST">
										{message}
										<div className={classes.centalArea}>
											<div>
												<input
													type="hidden"
													name="redirectURL"
													value={this.state.redirectURL}
												/>
												<TextField
													name="userName"
													label="User Name"
													className={classes.textField}
													value={this.state.data.userName}
													onChange={this.handleChange('userName')}
													margin="normal"
												/>
											</div>
											<div>
												<FormControl>
													<InputLabel htmlFor="password">Password</InputLabel>
													<Input
														name="password"
														type={self.state.showPassword ? 'text' : 'password'}
														value={self.state.data.password}
														onChange={self.handleChange('password')}
														className={classes.passwordField}
														endAdornment={
															<InputAdornment position="end">
																<IconButton onClick={self.handleClickShowPasssword}>
																	{self.state.showPassword ? (
																		<VisibilityOff />
																	) : (
																			<Visibility />
																		)}
																</IconButton>
															</InputAdornment>
														}
													/>
												</FormControl>
											</div>
										</div>
										<div className={classes.buttonBar}>

											<Button
												type="submit"
												variant="contained"
												color="primary"
												disabled={!this.state.data.password || !this.state.data.userName}
												className={classes.button}
											>
												Login
											</Button>
										</div>
										{
											<Typography
												className={classes.resetInstructions}
												variant="subtitle1"
												gutterBottom
											>
												{' '}
												<a href="/forgot-password"> Forgot your password?</a>
											</Typography>
										}
										{window["App"].allowUnsolicitedRegistration && (
											<Typography
												className={classes.resetInstructions}
												variant="subtitle1"
												gutterBottom
											>
												{' '}
											Not yet registered? <a href="/users/self-register"><b>Click Here</b></a> to register your account.
											</Typography>
										)}
									</form>
								</Grid>
							</Grid>
						)}
						{!window["App"].samlAvailable && (
							<Grid container>
								<Grid item className={classes.gridItem} xs={12} sm={12} md={12} lg={12} xl={12}>
									<form className={classes.form} action="/login" noValidate autoComplete="off" method="POST">
										{message}
										<div className={classes.centalArea}>
											<div>
												<input
													type="hidden"
													name="redirectURL"
													value={this.state.redirectURL}
												/>
												<TextField
													name="userName"
													label="User Name"
													className={classes.textField}
													value={this.state.data.userName}
													onChange={this.handleChange('userName')}
													margin="normal"
													fullWidth={true}
												/>
											</div>
											<div>
												<FormControl fullWidth={true}>
													<InputLabel htmlFor="password">Password</InputLabel>
													<Input
														name="password"
														type={self.state.showPassword ? 'text' : 'password'}
														value={self.state.data.password}
														onChange={self.handleChange('password')}
														className={classes.passwordField}
														endAdornment={
															<InputAdornment position="end">
																<IconButton onClick={self.handleClickShowPasssword}>
																	{self.state.showPassword ? (
																		<VisibilityOff />
																	) : (
																			<Visibility />
																		)}
																</IconButton>
															</InputAdornment>
														}
													/>
												</FormControl>
											</div>
										</div>


										<div className={classes.buttonBar}>
											<Button
												type="submit"
												variant="contained"
												color="primary"
												disabled={!this.state.data.password || !this.state.data.userName}
												className={classes.button}
											>
												Login
											</Button>
										</div>
										{
											<Typography
												className={classes.resetInstructions}
												variant="subtitle1"
												gutterBottom
											>
												{' '}
												<a href="/forgot-password"> Forgot your password?</a>
											</Typography>
										}
										{/* {window["App"].allowUnsolicitedRegistration && (
											<Typography
												className={classes.resetInstructions}
												variant="subtitle1"
												gutterBottom
											>
												{' '}
											Not yet registered? <a className="registerLink" href="/users/self-register"><b>Click Here</b></a> to register your account.
											</Typography>
										)} */}
									</form>
								</Grid>
							</Grid>
						)}
					</Paper>
				</div>
		);
        return returnValue
	}
}

export default withStyles(styles)(LoginRenderer);
